export const splitTextByCommaAndNewLine = (text) =>
  text
    .replace(/\n/g, ',')
    .split(/ *, */)
    .filter((value) => value)
